<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div class="d-flex ">
          <div class="perma-section-input pl-2">{{input}}</div>
          <div>
            <v-btn class="ex-remove-btn w-100 ma-0 mb-2" @click="remove()" color="error" dark large>Remove Chain</v-btn>
            <div class="perma-section text-center pt-3 pb-3">{{method}}</div>
            <div class="selector_chainlink">
              <div class="label mb-3">Save As : </div>
              <v-select v-show="output === 'database'"
                v-model="property"
                :items="properties"
                @change="addGlobalVars"
                label="No selection"
                item-text="text"
                solo
              >
              </v-select>
              <v-text-field @change="addGlobalVars" v-show="output === 'page'" v-model="pageName" placeholder="Page name"/>
              <v-checkbox
                    label="Apply fixnumber"
                    v-model="apply.fixnumber"
                  ></v-checkbox>
              <v-text-field v-model="use" placeholder="input"/>
            </div>
            <v-btn class="ex-add-btn  w-100 ma-0 mt-2" @click="add()" color="success" dark large>Add Chain</v-btn>
          </div>
          <div class="perma-section-output pr-2">{{output}}</div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'saveAs',
  props: ['x', 'y', 'variables'],
  data: () => ({
    destroy: false,
    apply: {
      fixnumber: false
    },
    property: '',
    properties: [
      'price',
      'availability',
      'shipping',
      'list-price',
      'unfiltered-list-price',
      'sku',
      'brand',
      'title',
      'ean',
      'mpn',
      'stock',
      'category',
      'alias_url_1',
      'shops_available',
      'shipping_available',
      'var2',
      'var3'
    ],
    use: '',
    result: '',
    input: '',
    method: '',
    output: '',
    pageName: ''
  }),
  methods: {
    addGlobalVars () {
      switch (this.output) {
        case 'database':
          if (this.property !== '') {
            this.$emit('addGlobalVars', this.y, this.x, [{id: this.property, value: ''}])
          }
          break
        case 'page':
          this.$emit('addGlobalVars', this.y, this.x, [{id: this.pageName, value: this.use}])
          break
      }
    },
    add () {
      this.$emit('add', this.y, this.x)
    },
    remove () {
      this.$emit('remove', this.y, this.x)
    }
  },
  computed: {},
  created () {
    this.addGlobalVars()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/selector/SaveAs.vue